import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

import useLineItemDetails from './useLineItemDetails'
import useAdValidationRequest from './useAdValidationRequest'

import { clearValidateAd } from '../../../../../../modules/actions/ads'
import { activeStepSelector, formPrevActiveStepSelector } from '../../../../../../modules/selectors/forms'

// FB does not currently have an endpoint to get valid domains linked to a pixel,
// therefore we first need to test the ad creation using the click through link's
// 1st and 2nd level domain with a validation check,
// and if that passes we can create the ad with the domain when the user presses save.
// If it does not pass validation, on save we try to create without the domain.
export default function useValidateConversionDomain({ values, isStepActive, selectedApplicationId }) {
  const dispatch = useDispatch()
  const [allowToValidate, setAllowToValidate] = useState(false)

  const activeStepIndex = useSelector(activeStepSelector)
  const prevActiveStepIndex = useSelector(formPrevActiveStepSelector)

  const { lineItemId } = useLineItemDetails()
  const makeValidationRequest = useAdValidationRequest(values, selectedApplicationId)

  useEffect(() => {
    // lineItemId could be missed for cases when ad is creating within campaign and line item for e.g. in Media order
    if (allowToValidate && lineItemId) {
      makeValidationRequest()
      setAllowToValidate(false)
    }
  }, [allowToValidate, lineItemId, makeValidationRequest])

  useEffect(() => {
    if (isStepActive && prevActiveStepIndex < activeStepIndex) {
      setAllowToValidate(true)
    }
  }, [isStepActive, prevActiveStepIndex, activeStepIndex])

  useEffect(() => {
    return () => {
      dispatch(clearValidateAd())
    }
  }, [dispatch])
}
